import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const routes = [
  {
    path: "/login", // 登录
    name: "login",
    component: () => import("@/views/login/index.vue")
  },
  {
    path: "/register", // 注册
    name: "register",
    component: () => import("@/views/register/index.vue")
  },
  {
    path: "/forget", // 忘记密码
    name: "forget",
    component: () => import("@/views/forget/index.vue")
  },
  {
    path: "/",
    component: () => import("@/views/layout/index.vue"),
    children: [
      {
        path: "", // 首页
        name: "home",
        component: () => import("@/views/home/index.vue")
        // meta: {
        //   footer: true
        // },
      },
      {
        path: "rate", // 费率
        name: "rate",
        component: () => import("@/views/rate/index.vue")
      },
      {
        path: "trade", // 购买/出售
        name: "trade",
        component: () => import("@/views/trade/index.vue")
      },
      {
        path: "advertise", // 发布广告
        name: "advertise",
        component: () => import("@/views/advertise/index.vue"),
        meta: {
          requiresAuth: true
        }
      },
      // {
      //   path: 'loan',
      //   component: () =>
      //     import('@/views/loan/index.vue'),
      //   children: [{
      //     path: '', // 我要借贷
      //     name: 'loan',
      //     component: () =>
      //       import('@/views/loan/loan.vue')
      //   }, {
      //     path: 'financing', // 我要理财
      //     name: 'financing',
      //     component: () =>
      //       import('@/views/loan/financing.vue'),
      //     meta: {
      //       requiresAuth: true
      //     }
      //   },
      //   {
      //     path: 'order/:id', // 借贷订单
      //     name: 'loan-order',
      //     component: () =>
      //       import('@/views/loan/order.vue')
      //   }, {
      //     path: 'trade/:id', // 借贷交易
      //     name: 'loan-trade',
      //     component: () =>
      //       import('@/views/loan/trade.vue'),
      //     meta: {
      //       requiresAuth: true
      //     }
      //   }]
      // },
      {
        path: "invite", // 邀请好友
        name: "invite",
        component: () => import("@/views/invite/index.vue"),
        meta: {
          // requiresAuth: true
        }
      },
      {
        path: "share", //分享
        name: "share",
        component: () => import("@/views/invite/index.vue")
      },
      {
        path: "wallet", // 钱包
        component: () => import("@/views/wallet/index.vue"),
        meta: {
          requiresAuth: true
        },
        children: [
          {
            path: "recharge", // 充值
            name: "recharge",
            component: () => import("@/views/wallet/recharge.vue"),
            meta: {
              alive: true
            }
          },
          {
            path: "withdraw", // 提现
            name: "withdraw",
            component: () => import("@/views/wallet/withdraw.vue"),
            meta: {
              alive: true
            }
          },
          {
            path: "trade", // 交易记录
            name: "tradeRecord",
            component: () => import("@/views/wallet/tradeRecord.vue"),
            meta: {
              alive: true
            }
          },
          {
            path: "mywallet", // 财富钱包
            name: "mywallet",
            component: () => import("@/views/wallet/mywallet.vue")
          },
          {
            path: "financial", // 金融账户
            name: "walletFinancial",
            component: () => import("@/views/wallet/financial.vue")
          }
          ,
          {
            path: "marginAccount", // 杠杆账户
            name: "marginAccount",
            component: () => import("@/views/wallet/marginAccount.vue")
          },
          {
            path: "accountStatement", // 账户结单
            name: "accountStatement",
            component: () => import("@/views/wallet/accountStatement.vue")
          },
        ]
      },
      {
        path: "order",
        component: () => import("@/views/order/index.vue"),
        children: [
          {
            path: ":orderId", // 订单
            name: "order",
            component: () => import("@/views/order/order.vue")
          },
          {
            path: "details/:id", // 订单详情
            name: "order-details",
            component: () => import("@/views/order/details.vue")
          }
        ]
      },
      {
        path: "profile", // 用户简介
        name: "profile",
        component: () => import("@/views/profile/index.vue")
      },
      {
        path: "user", // 用户中心
        component: () => import("@/views/user/index.vue"),
        meta: {
          requiresAuth: true
        },
        children: [
          {
            path: "basic", // 基础信息
            name: "basic",
            component: () => import("@/views/user/basic.vue"),
            meta: {
              title: "Basic information"
            }
          },
          {
            path: "account-security", // 账户安全
            name: "account-security",
            component: () => import("@/views/user/account-security.vue"),
            meta: {
              title: "Account security"
            }
          },
          {
            path: "business-auth", //
            component: () => import("@/views/user/auth/business-auth.vue"),
            meta: {
              title: "Authentication"
            }
          },
          {
            path: "choice",
            name: "choice",
            component: () => import("@/views/user/auth/choice.vue"),
            meta: {
              title: "Authentication"
            }
          },
          {
            path: "business-success", // 企业认证成功
            name: "business-success",
            component: () => import("@/views/user/auth/business-success.vue")
          },
          {
            path: "auth", // 身份验证
            component: () => import("@/views/user/auth/index.vue"),
            meta: {
              title: "Authentication"
            },
            children: [
              {
                path: "fill-info", // 填写资料
                name: "fill-info",
                component: () => import("@/views/user/auth/fillInfo.vue"),
                meta: {
                  parentsPath: "/user/auth"
                }
              },
              {
                path: "upload-img", // 上传图片
                name: "upload-img",
                component: () => import("@/views/user/auth/uploadImg.vue"),
                meta: {
                  parentsPath: "/user/auth"
                }
              },
              {
                path: "examine", // 系统审核
                name: "examine",
                component: () => import("@/views/user/auth/examine.vue"),
                meta: {
                  parentsPath: "/user/auth"
                }
              },
              {
                path: "success", // 认证成功
                name: "success",
                component: () => import("@/views/user/auth/success.vue"),
                meta: {
                  parentsPath: "/user/auth"
                }
              }
            ]
          },
          {
            path: "payment-setting", // 支付设置
            name: "payment-setting",
            component: () => import("@/views/user/payment-setting.vue"),
            meta: {
              title: "Payment settings"
            }
          },
          // {
          //   path: 'event-subscribe', // 事件订阅
          //   name: 'event-subscribe',
          //   component: () =>
          //     import('@/views/user/event-subscribe.vue'),
          //   meta: {
          //     title: 'Event subscription'
          //   }
          // },
          {
            path: "court-order", // 场外订单
            name: "court-order",
            component: () => import("@/views/user/court-order.vue"),
            meta: {
              title: "Court orders"
            }
          },
          {
            path: "loan-order", // 借贷订单
            name: "user-loan-order",
            component: () => import("@/views/user/loan-order.vue"),
            meta: {
              title: "Loan orders"
            }
          },
          {
            path: "buy-ads", // 购买广告
            name: "buy-ads",
            component: () => import("@/views/user/buy-ads.vue"),
            meta: {
              title: "Buying"
            }
          },
          {
            path: "selling-ads", // 出售广告
            name: "selling-ads",
            component: () => import("@/views/user/selling-ads.vue"),
            meta: {
              title: "Selling"
            }
          },
          {
            path: "financing-ads", // 理财广告
            name: "financing-ads",
            component: () => import("@/views/user/financing-ads.vue"),
            meta: {
              title: "Financial advertising"
            }
          },
          {
            path: "you-trust", // 您信任的人
            name: "you-trust",
            component: () => import("@/views/user/you-trust.vue"),
            meta: {
              title: "Trusting"
            }
          },
          {
            path: "trust-you", // 信任您的人
            name: "trust-you",
            component: () => import("@/views/user/trust-you.vue"),
            meta: {
              title: "Trusted by"
            }
          },
          {
            path: "you-shield", // 您屏蔽的人
            name: "you-shield",
            component: () => import("@/views/user/you-shield.vue"),
            meta: {
              title: "Blocked"
            }
          }
        ]
      },
      {
        path: "/financial", // 财富
        name: "financial",
        component: () => import("@/views/financial/index.vue")
      },
      {
        path: "/financial/earn", // 币宝
        name: "financialEarn",
        component: () => import("@/views/financial/earn.vue")
      },
      {
        path: "/financial/buy", // 申购
        name: "financialBuy",
        component: () => import("@/views/financial/buy.vue")
      },
      {
        path: "/financial/deb", // 得亿宝
        name: "financialDeb",
        component: () => import("@/views/financial/deb.vue")
      },
      {
        path: "/financial/dco", // AUDCO矿机
        name: "financialDco",
        component: () => import("@/views/financial/dco.vue")
      },
      {
        path: "account",
        component: () => import("@/views/account/index.vue"),
        meta: {
          requiresAuth: true
        },
        children: [
          {
            path: "update-pwd", // 修改登录密码
            name: "update-pwd",
            component: () => import("@/views/account/update-pwd.vue"),
            meta: {
              title: "Change login password"
            }
          },
          {
            path: "bind-email", // 绑定邮箱
            name: "bind-email",
            component: () => import("@/views/account/bind-email.vue"),
            meta: {
              title: "Bind email"
            }
          },
          {
            path: "update-mobile", // 修改手机
            name: "update-mobile",
            component: () => import("@/views/account/update-mobile.vue"),
            meta: {
              title: "Modify the phone"
            }
          },
          {
            path: "google-auth", // 谷歌验证
            name: "google-auth",
            component: () => import("@/views/account/google-auth.vue"),
            meta: {
              title: "Bind Google Verification"
            }
          },
          {
            path: "capital-pwd", // 资金密码
            component: () => import("@/views/account/capital-pwd/index.vue"),
            children: [
              {
                path: "create", // 创建资金密码
                name: "create-capital-pwd",
                component: () =>
                  import("@/views/account/capital-pwd/create.vue"),
                meta: {
                  title: "create secondary password"
                }
              },
              {
                path: "update", // 修改资金密码
                name: "update-capital-pwd",
                component: () =>
                  import("@/views/account/capital-pwd/update.vue"),
                meta: {
                  title: "Amend the capital cipher"
                }
              },
              {
                path: "reset", // 重置资金密码
                name: "reset-capital-pwd",
                component: () =>
                  import("@/views/account/capital-pwd/create.vue"),
                meta: {
                  title: "Reset secondary password"
                }
              }
            ]
          }
        ]
      },
      {
        path: "exchange", // 币币交易
        name: "exchange",
        component: () => import("@/views/exchange/index.vue"),
        meta: {
          // requiresAuth: true
        }
      },
      {
        path: "lever", // 杠杆交易
        name: "lever",
        component: () => import("@/views/lever/index.vue")
      },
      {
        path: "transaction", // 合约交易
        name: "transaction",
        component: () => import("@/views/transaction/index.vue"),
        meta: {
          // requiresAuth: true
        }
      },
      {
        path: "contract-open", // 合约开通
        name: "contract-open",
        component: () =>
          import("@/views/transaction/components/contract-open.vue")
      },
      {
        path: "activity", // 活动
        name: "activity",
        component: () => import("@/views/activity/index.vue")
      },
      {
        path: "activity-details", // 活动详情
        name: "activity-details",
        component: () => import("@/views/activity/activity-details.vue")
      },
      {
        path: "help", // 帮助中心
        name: "help",
        component: () => import("@/views/help/index.vue")
      },
      {
        path: "sys", // 系统文档
        name: "sys",
        component: () => import("@/views/sys/index.vue")
        // meta: {判断头部header是否显示
        //   title: "sys"
        // },
      },
      {
        path: "notice", // 帮助中心
        name: "notice",
        component: () => import("@/views/notice/index.vue")
      },
      {
        path: "notice-details", // 帮助中心
        name: "notice-details",
        component: () => import("@/views/notice/notice-details.vue")
      },
      {
        path: "news", // 新闻资讯
        name: "news",
        component: () => import("@/views/news/index.vue")
      },
      {
        path: "news-details", // 新闻资讯
        name: "news-details",
        component: () => import("@/views/news/news-details.vue")
      },
      {
        path: "problem", // 常见问题
        name: "problem",
        component: () => import("@/views/problem/index.vue")
      },
      {
        path: "problem-details", // 常见问题详情
        name: "problem-details",
        component: () => import("@/views/problem/problem-details.vue")
      },
      {
        path: "clause", // 条款说明
        name: "clause",
        component: () => import("@/views/clause/index.vue")
      },
      {
        path: "tutorials", // DEAX App Tutorials
        name: "tutorials",
        component: () => import("@/views/tutorials/index.vue")
      },
      {
        path: "agreement-details", // 条款说明协议详情
        name: "agreement-details",
        component: () => import("@/views/clause/agreement-details.vue")
      },
      {
        path: "privacy-details", // 条款说明隐私详情
        name: "privacy-details",
        component: () => import("@/views/clause/privacy-details.vue")
      },
      {
        path: "law-details", // 条款说明法律详情
        name: "law-details",
        component: () => import("@/views/clause/law-details.vue")
      },
      {
        path: "about", // 关于我们
        name: "about",
        component: () => import("@/views/about/index.vue")
      },
      {
        path: "comapny", // 关于我们公司介绍
        name: "comapny",
        component: () => import("@/views/about/comapny.vue")
      },
      {
        path: "us", // 关于我们联系方式
        name: "us",
        component: () => import("@/views/about/us.vue")
      },
      {
        path: "currency", // 关于我们上币申请
        name: "currency",
        component: () => import("@/views/about/currency.vue")
      },
      {
        path: "market", // 市场
        name: "market",
        component: () => import("@/views/market/index.vue"),
        meta: {
          // requiresAuth: true
        }
      },
      {
        path: "destroyData", // DAEX销毁数据
        name: "destroyData",
        component: () => import("@/views/destroyData/index.vue"),
        meta: {
          // requiresAuth: true
        }
      },
			{
			  path: '/serve',
			  name: 'serve',
			  component: () => import('@/views/serve/index.vue')
			}
    ]
  },
  {
    path: "/luckDraw", // 新用户抽奖
    name: "luckDraw",
    component: () => import("@/views/luckDraw/index.vue"),
    meta: {
      // requiresAuth: true
    }
  },
  {
    path: "/luckDraw/history", // 历史中奖记录
    name: "luckDrawHistory",
    component: () => import("@/views/luckDraw/history.vue"),
    meta: {
      // requiresAuth: true
    }
  },
  {
    path: "",
    component: () => import("@/views/layout/index2.vue"),
    children: [
      {
        path: "/quickBuy", // 一键购买
        name: "quickBuy",
        component: () => import("@/views/quickBuy/index.vue"),
        meta: {
          // requiresAuth: true
        }
      },
      {
        path: "/quickBuy/confirm", // 确认订单
        name: "quickBuyConfirm",
        component: () => import("@/views/quickBuy/confirm.vue"),
        meta: {
          // requiresAuth: true
        }
      },
      {
        path: "/quickBuy/search", // 订单查询
        name: "quickBuySearch",
        component: () => import("@/views/quickBuy/search.vue"),
        meta: {
          // requiresAuth: true
        }
      },
      {
        path: "/purchase-agreement", // 买币协议
        name: "purchaseAgreement",
        component: () => import("@/views/purchase-agreement/index.vue")
      },
      {
        path: "/statement-terms", // 声明以及条款
        name: "statementTerms",
        component: () => import("@/views/statement-terms/index.vue")
      }
    ]
  },
  {
    path: "/404",
    name: "notFound",
    component: () => import("@/views/error/404.vue")
  },
  {
    path: "*",
    redirect: "/404"
  }
];

export default new Router({
  mode: "history",
  scrollBehavior: () => ({
    y: 0
  }),
  routes
});



// WEBPACK FOOTER //
// ./src/router/index.js